export default function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      className="border border-[#1a1a1a] bg-[#0d0d0d] rounded-lg py-20 px-6 flex flex-col items-center text-center"
      data-testid={testId || "empty-state"}
    >
      {Icon && (
        <div className="w-12 h-12 rounded-md border border-[#1f1f1f] bg-[#121212] flex items-center justify-center mb-5">
          <Icon className="w-5 h-5 text-neutral-500" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-display text-xl font-medium tracking-tight">{title}</h3>
      {description && (
        <p className="text-neutral-500 text-sm mt-2 max-w-md leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
